import { APP_INITIALIZER, Provider } from '@angular/core';
import { SupportActivityTrackerService } from './services/support-activity-tracker.service';

/**
 * Starts the activity history at bootstrap, so an issue report also covers
 * what happened before the chat was first opened. The HTTP side is
 * `SupportActivityInterceptor` (registered in AppModule).
 */
export function provideSupportSystem(): Provider[] {
  return [
    {
      provide: APP_INITIALIZER,
      multi: true,
      deps: [SupportActivityTrackerService],
      useFactory: (tracker: SupportActivityTrackerService) => () =>
        tracker.start(),
    },
  ];
}
